import {Component, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from '@angular/forms';
import {ModalDirective} from "ng2-bootstrap";
import {HttpService} from '../../../core/services/http.service';
import {environment} from "../../../../environments/environment";

export class UserModel {
  id: number;
  username: string = '';
  firstname: string = '';
  lastname: string = '';
  email: string = '';
  password: string ='';
  is_enabled: boolean = false;
}

@Component({
  selector: 'user-modal',
  templateUrl: './user.modal.component.html',
  styleUrls: [ './user.modal.component.scss' ]
})
export class UserModalComponent {
  public user: UserModel = new UserModel();

  @ViewChild('userModal') public userModal: ModalDirective;

  @Output()
  refreshList = new EventEmitter<boolean>();

  @Input()
  setModalMode;

  username: FormControl = new FormControl("",Validators.required);
  firstname: FormControl = new FormControl("",Validators.required);
  lastname: FormControl = new FormControl("",Validators.required);
  email: FormControl = new FormControl("",Validators.required);
  password: FormControl = new FormControl("");
  is_enabled: FormControl = new FormControl("",Validators.required);
  userForm: FormGroup;

  errors: any;

  constructor( //private api: ApiService,
              private fb: FormBuilder,
              private http: HttpService
  ) {

    this.userForm = fb.group({
      'id': [null],
      'username': this.username,
      'firstname': this.firstname,
      'lastname': this.lastname,
      'email': this.email,
      'password': this.password,
      'is_enabled': this.is_enabled
    });

  }

  buildForm() {
    this.userForm.reset();
    this.userForm.patchValue(this.user);
  }

  private backendUrl = environment.backendUrl;

  show(user) {
    if(user) {
      this.user = user;
    }
    else {
      this.user = new UserModel();
    }

    this.buildForm();

    this.userModal.show(); 
  }

  onSubmit(event) {
    if (!this.userForm.valid) {
      return;
    }

    this.user = this.userForm.value;

    if(this.user.id) {
      this.http.put(this.backendUrl+'api/user/'+this.user.id, this.userForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.userModal.hide(); 
                  this.userForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }
    else {
      this.http.post(this.backendUrl+'api/user/create', this.userForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.userModal.hide(); 
                  this.userForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }

  } 

}





// WEBPACK FOOTER //
// /code/frontend/src/app/main/users/modals/user.modal.component.ts